import { Navigation, Promobar } from '@boozt/app/components/organisms';
import type { ReactNode } from 'react';

type PageProps = {
    children: ReactNode;
};

export default function DefaultLayout({ children }: PageProps) {
    return (
        <>
            <Promobar />
            <Navigation />
            <div className="page-container">
                {children}
            </div>
        </>
    );
}
